/**
 * Shared team hunt timer math (player countdown, host display, score deductions).
 */

const DEFAULT_DURATION_MINUTES = 2

export const getTeamElapsedSeconds = (team, now = Date.now()) => {
  const huntStart = team && team.start_time
  if (!huntStart) return 0

  let endMs = now
  const huntEnd = team.end_time
  if (huntEnd) {
    endMs = Date.parse(huntEnd)
  }

  return Math.floor((endMs - Date.parse(huntStart)) / 1000)
}

export const durationSeconds = (durationMinutes) => {
  const minutes = durationMinutes !== undefined ? durationMinutes : DEFAULT_DURATION_MINUTES
  return minutes * 60
}

export const getTeamSecondsLeft = (team, durationMinutes, enableTimer, now = Date.now()) => {
  if (!enableTimer) return null
  if (!team || !team.start_time) return null

  const duration = durationSeconds(durationMinutes)
  const elapsed = getTeamElapsedSeconds(team, now)
  return duration - elapsed
}

export const secondsToTimeParts = (secs) => {
  const absSecs = Math.abs(secs)
  return {
    h: Math.floor(absSecs / 3600),
    m: Math.floor(absSecs / 60) % 60,
    s: Math.ceil(absSecs % 60),
  }
}

export const formatTimeLeft = (seconds) => {
  if (seconds === null || seconds === undefined) return null

  let isNegative = false
  let secs = seconds
  if (secs < 0) {
    isNegative = true
    secs = -secs
  }

  const timeObj = secondsToTimeParts(secs)
  const hours = timeObj.h.toLocaleString(`en-US`, { minimumIntegerDigits: 2, useGrouping: false })
  const minutes = timeObj.m.toLocaleString(`en-US`, { minimumIntegerDigits: 2, useGrouping: false })
  const secondsPart = timeObj.s.toLocaleString(`en-US`, { minimumIntegerDigits: 2, useGrouping: false })
  let returnString = `${hours}:${minutes}:${secondsPart}`
  if (isNegative) {
    returnString = `-${returnString}`
  }
  return returnString
}

export const getTeamTimeDeduction = (team, durationMinutes, enableTimer, now = Date.now()) => {
  const secondsLeft = getTeamSecondsLeft(team, durationMinutes, enableTimer, now)
  if (secondsLeft === null || secondsLeft >= 0) return 0

  const fiveMinIntervals = Math.floor(-secondsLeft / 60 / 5)
  return 3 * fiveMinIntervals
}
